import { TFunction } from 'i18next';
import { ISimpleUserForAprove } from 'interfaces';
import classes from '../SingingTab.module.scss';

export interface IUserSigning extends ISimpleUserForAprove {
  user_group?: string;
  document_name?: string;
  signing_date?: string;
  room?: string;
  key?: string
}

export const getColumnsCertificate = (t: TFunction) => [
  {
    title: t('Documents.details.signing.userName'),
    dataIndex: 'user_name',
    key: 'user_name',
    width: '35%',
  },
  {
    title: t('Documents.details.signing.date'),
    dataIndex: 'signing_date',
    key: 'signing_date',
    width: '45%',
  },
  {
    title: t('Documents.details.signing.state'),
    dataIndex: 'signing_status',
    key: 'signing_status',
    width: '20%',
    className: classes.textToCenter,
  },
];
